<template>
  <div class="partnerDetails" v-if="detailsData">
    <headers />
    <div class="partnerDetailsHero">
      <img src="@/assets/images/communityBj.png" alt="" />
      <h1 class="partnerDetailsHeroTitle">合作伙伴详情</h1>
    </div>

    <main class="partnerDetailsMain">
      <div class="partnerDetailsInner">
        <!-- 合作伙伴详情信息卡片 -->
        <partner-detail-card :data="detailsData" />

        <div class="partnerDetailsTabs">
          <!-- 合作伙伴详情Tabs -->
          <button
            v-for="tab in tabList"
            :key="tab.key"
            type="button"
            class="partnerDetailsTab"
            :class="{ 'is-active': activeTab === tab.key }"
            @click="activeTab = tab.key"
          >
            {{ tab.label }}
          </button>
        </div>

        <div class="partnerDetailsPanel">
          <!-- 企业信息 -->
          <partner-company-info
            v-if="activeTab === 'company'"
            :data="detailsData"
          />
          <!-- 业绩信息 -->
          <partner-performance-info
            v-else-if="activeTab === 'performance'"
            :data="detailsData"
          />
          <!-- 合同信息 -->
          <partner-contract-info
            v-else-if="activeTab === 'contract'"
            :data="detailsData"
          />
          <!-- 项目信息 -->
          <partner-projects
            v-else-if="activeTab === 'projects'"
            :data="detailsData"
          />
        </div>
      </div>
    </main>

    <footers />
  </div>
</template>

<script>
import headers from "@/components/header.vue";
import footers from "@/components/footer.vue";
import { getFactoryDetails } from "@/api/lx";
import PartnerDetailCard from "./components/PartnerDetailCard.vue";
import PartnerCompanyInfo from "./components/PartnerCompanyInfo.vue";
import PartnerPerformanceInfo from "./components/PartnerPerformanceInfo.vue";
import PartnerContractInfo from "./components/PartnerContractInfo.vue";
import PartnerProjects from "./components/PartnerProjects.vue";

const TAB_LIST = [
  { key: "company", label: "企业信息" },
  { key: "performance", label: "业绩信息" },
  { key: "contract", label: "授权协议" },
  { key: "projects", label: "项目" },
];

export default {
  name: "CommunityDetails",
  components: {
    headers,
    footers,
    PartnerDetailCard,
    PartnerCompanyInfo,
    PartnerPerformanceInfo,
    PartnerContractInfo,
    PartnerProjects,
  },
  data() {
    return {
      tabList: TAB_LIST,
      activeTab: "company",
      detailsData: null,
    };
  },
  created() {
    this.fetchFactoryDetails();
  },
  methods: {
    async fetchFactoryDetails() {
      const res = await getFactoryDetails(this.$route.query.id);
      if (res.code !== 200) return;

      // 兼容处理：将英文逗号连接的权益名称字符串转换为数组，以适配子组件内的条件匹配逻辑
      let equityClassifyNames = [];
      if (res.data.equityClassifyNames) {
        if (Array.isArray(res.data.equityClassifyNames)) {
          equityClassifyNames = res.data.equityClassifyNames;
        } else if (typeof res.data.equityClassifyNames === "string") {
          equityClassifyNames = res.data.equityClassifyNames
            .split(",")
            .filter(Boolean);
        }
      }

      // 提取 L1 和 L2 的授权起止日期以适配子组件展示
      const l1Classify = (res.data.equityClassifyList || []).find(
        (item) => item.equityClassifyName === "L1"
      );
      const l2Classify = (res.data.equityClassifyList || []).find(
        (item) => item.equityClassifyName === "L2"
      );

      const newData = {
        ...res.data,
        l1StartDate: l1Classify ? l1Classify.startTime : "",
        l1EndDate: l1Classify ? l1Classify.endTime : "",
        l2StartDate: l2Classify ? l2Classify.startTime : "",
        l2EndDate: l2Classify ? l2Classify.endTime : "",
        video: res.data.video
          ? res.data.video.split(",").filter((item) => item.trim())
          : [],
        equityClassifyNames,
        projects: res.data.projects || [],
      };

      if (newData.details) {
        newData.details = newData.details.replace(/<img[^>]*>/g, (match) =>
          match.replace(/style="[^"]*"/, 'style="width: 100%!important;"')
        );
      }

      this.detailsData = newData;
    },
  },
};
</script>

<style lang="less" scoped>
.partnerDetails {
  background: #f5f7f9;
  min-height: 100vh;
  display: flex;
  flex-direction: column;
}
.partnerDetailsHero {
  position: relative;
  height: 256px;
  overflow: hidden;
  img {
    position: absolute;
    inset: 0;
    width: 100%;
    height: 100%;
    object-fit: cover;
  }
}
.partnerDetailsHeroTitle {
  position: relative;
  z-index: 1;
  margin: 0;
  padding-top: 96px;
  text-align: center;
  font-size: 36px;
  font-weight: 700;
  color: #fff;
  letter-spacing: 0.1em;
}
.partnerDetailsMain {
  flex: 1;
  padding-bottom: 48px;
}
.partnerDetailsInner {
  max-width: 1200px;
  margin: -48px auto 0;
  padding: 0 16px;
  position: relative;
  z-index: 2;
}
.partnerDetailsTabs {
  display: flex;
  background: #fff;
  border-bottom: 1px solid #e5e7eb;
}
.partnerDetailsTab {
  padding: 16px 32px;
  border: none;
  border-bottom: 2px solid transparent;
  background: none;
  font-size: 14px;
  font-weight: 500;
  color: #64748b;
  cursor: pointer;
  transition: color 0.2s, border-color 0.2s;
  &:hover {
    color: #00bcd4;
  }
  &.is-active {
    color: #00bcd4;
    border-bottom-color: #00bcd4;
  }
}
.partnerDetailsPanel {
  background: #fff;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.04);
}
</style>
